document.addEventListener("DOMContentLoaded", function () {
  // Get the script tag with the translations
  const scriptTag = document.querySelector('script[data-title]');
  
  // Get translations from data attributes
  const translations = {
    title: scriptTag ? scriptTag.getAttribute('data-title') : '30 Tage kostenlos testen, dann bezahlen!',
    description: scriptTag ? scriptTag.getAttribute('data-description') : '<strong>Du möchtest Dich vor dem Bezahlen von den Vorteilen dieses Produkts überzeugen?</strong>\n\nBestelle jetzt und entscheide Dich während des 30 Tage Probezeitraums, ob Du das Produkt behälst oder kostenfrei zurückschickst. \n<strong>Kein Risiko, keine versteckten Kosten</strong> - einfach ausprobieren!',
    buyNow: scriptTag ? scriptTag.getAttribute('data-buy-now') : 'Buy Now'
  };

  // Update the tryonify elements
  function updateTryonifyTexts() {
    // 1. Update title
    const titleElements = document.querySelectorAll(
      ".tryonify-selling-plan-name"
    );
    titleElements.forEach((element) => {
      // Only update the first element with the title text (not the Buy Now one)
      if (!element.closest(".tryonify-selling-plan--default")) {
        element.textContent = translations.title;
      }
    });

    // 2. Update description
    const descriptionElements = document.querySelectorAll(
      ".tryonify-selling-plan-description"
    );
    descriptionElements.forEach((element) => {
      // Parse HTML content safely
      element.innerHTML = translations.description;
    });

    // 3. Update buy now text
    const buyNowElements = document.querySelectorAll(
      ".tryonify-selling-plan--default .tryonify-selling-plan-name"
    );
    buyNowElements.forEach((element) => {
      element.textContent = translations.buyNow;
    });
  }

  // Run the update function
  updateTryonifyTexts();

  // Also run when the page content might change (e.g., after variant selection)
  document.addEventListener("variant:change", updateTryonifyTexts);

  // MutationObserver to detect dynamically added tryonify elements
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        const tryonifyAdded = Array.from(mutation.addedNodes).some((node) => {
          return (
            node.nodeType === 1 &&
            (node.classList?.contains("tryonify-selling-plan-group") ||
              node.querySelector?.(".tryonify-selling-plan-group"))
          );
        });

        if (tryonifyAdded) {
          updateTryonifyTexts();
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
